const state = {
  loading: null,
  firstLoad: false,
  showFooter: false,
  hideLoadingScreen: false,
  inactivityTimeout: null,
  message: {
    text: null,
    color: null,
    show: null,
    redirect: null,
    timeout: parseInt(process.env.VUE_APP_MESSAGE_TIMEOUT, 10),
  },
  formErrors: null,
  error: null,
  historyCount: null,
  showSideMenu: false,
}

const getters = {
  historyLength: (state) => window.history.length - state.historyCount,
}

const actions = {
}

const mutations = {
  setError (state, error) {
    state.error = error
  },
  setLoading (state, value) {
    if (state.formErrors && value) {
      state.formErrors = null
    }
    state.loading = value
  },
  setMessage (state, message) {
    state.message = {
      text: null,
      color: null,
      show: null,
      redirect: null,
      timeout: parseInt(process.env.VUE_APP_MESSAGE_TIMEOUT, 10),
    }
    state.message.text = message.text
    state.message.color = message.color
    state.message.timeout = (message.timeout !== undefined)
      ? message.timeout
      : parseInt(process.env.VUE_APP_MESSAGE_TIMEOUT, 10)
    if (message.redirect) {
      state.message.redirect = message.redirect
    }
    state.message.show = true
  },
  setFormErrors (state, errors) {
    state.formErrors = errors
  },
  setShowSideMenu (state, show) {
    state.showSideMenu = show
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
